// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardFilterDescriptions.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
import React, { PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import FilterDescription from 'modules/Reports/ReportViewer/Izenda.FilterDescription';
import action from './Izenda.DashboardFilterDescriptionsAction';

const DashboardFilterDescriptions = function DashboardFilterDescriptions(props) {
  const { localization, dashboardPart, operatorSource } = props;

  return (
    <div className='izenda-DashboardTile-FilterDescription'>
      <div className='u_tableCell'>
        <label>{localization.getText('DASHBOARD_LABEL_FILTER_DESCRIPTIONS')}</label>
      </div>
      <div className='u_tableCell'>
        <GridLayout className='izenda-DashboardTile-FilterDescription_GridLayout'>
          {dashboardPart.fullConfigFieldList.map(function(configField, position) {
            return (
              <GridLayout.Row key={position}>
                <GridLayout.Col>
                  <FilterDescription
                    field={configField}
                    position={position + 1}
                    operatorSource={operatorSource}
                    filterSource={dashboardPart.individualConfigFieldList}
                  />
                </GridLayout.Col>
              </GridLayout.Row>
            );
          })}
        </GridLayout>
      </div>
    </div>
  );
};

DashboardFilterDescriptions.propTypes = {
  dashboardPart: PropTypes.object
};

export default connect(action)(DashboardFilterDescriptions);



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/ReportPartTile/Izenda.DashboardFilterDescriptions.js